import { render, staticRenderFns } from "./goodsItemEdit.vue?vue&type=template&id=5c4fc53d"
import script from "./goodsItemEdit.vue?vue&type=script&lang=js"
export * from "./goodsItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports